import { put, call } from 'redux-saga/effects';
import { IResponse } from '@dash/apiInstance';
import ApiInstance from '../../helpers/apiInstance';
import { sendRequest } from '../../helpers/saga';
import actions from './actions';
import { IPermissionsData } from './types';

const api = new ApiInstance('permissions');

function* fetchPermissions(): Generator<any, void, any> {
  const result: IResponse<{ permissions?: IPermissionsData }> = yield call(
    sendRequest,
    api.get,
    {},
    actions.FETCH_PERMISSIONS_ERROR,
  );

  // `apiHelpers.parseJSON` already unwraps the `{ success: { data } }` envelope into `result.data`,
  // so by the time we read it here the permissions object lives at `result.data.permissions`.
  const livePermissions = result?.data?.permissions;

  if (result?.status === 200 && livePermissions) {
    yield put(actions.fetchPermissionsSuccess(livePermissions));
  }
}

export { fetchPermissions };
